module.exports = __webpack_public_path__ + "static/img/soumission-sleeves.91bdb87d.jpg";